import client from "../api/client";
import { audioFromBase64, playBase64Mp3 } from "./audioUnlock";
import { speakWithBrowser } from "./speechFallback";
import { clockParams, slotStamp } from "./greetingSlot";

const CACHE_VERSION = "v12"; // ارفع الرقم لإبطال كل التحيات المخزّنة عالمياً
const cacheKey = (userId) => `greeting_${CACHE_VERSION}_${slotStamp()}_${userId}`;
const fetchGreeting = () => client.get("/attendance/greeting", { params: clockParams() });

const read = (userId) => {
  try {
    return JSON.parse(localStorage.getItem(cacheKey(userId)) || "null");
  } catch {
    return null;
  }
};

const remove = (userId) => {
  try {
    localStorage.removeItem(cacheKey(userId));
  } catch {
    /* لا شيء */
  }
};

const write = (userId, audio, mime) => {
  try {
    localStorage.setItem(cacheKey(userId), JSON.stringify({ audio, mime }));
  } catch {
    /* الذاكرة ممتلئة — نتجاهل الكاش */
  }
};

const toAudio = ({ audio, mime }) => {
  const el = audioFromBase64(audio, mime);
  el._base64 = audio;
  return el;
};

// يجب أن تُنادى داخل نقرة المستخدم (سياسة التشغيل التلقائي في iOS): تُهيّئ الصوت بلا تشغيل.
export const prepareGreeting = (userId) => {
  const cached = read(userId);
  if (!cached?.audio) return null;
  const audio = toAudio(cached);
  try {
    audio.load();
  } catch {
    /* لا شيء */
  }
  return audio;
};

export const playPrepared = async (audio) => {
  if (!audio) return false;
  try {
    await audio.play();
    return true;
  } catch {
    return playBase64Mp3(audio._base64);
  }
};

// المسار الكامل: كاش المتصفح ← الخادم ← تخزين ← تشغيل. وإن تعذّر توليد الصوت على الخادم
// يُنطق النص عبر محرّك المتصفح حتى لا يصمت التطبيق أبداً.
export const speakGreeting = async (userId, lang = "ar") => {
  try {
    if (read(userId)?.audio) return playPrepared(prepareGreeting(userId));
    const { data } = await fetchGreeting();
    if (data?.disabled) {
      remove(userId);
      return false;
    }
    if (!data?.audio) return speakWithBrowser(data?.text, lang);
    write(userId, data.audio, data.mime);
    return playPrepared(toAudio(data));
  } catch {
    return false;
  }
};

// تسخين الكاش بعد نجاح الحضور حتى تُسمع التحية فوراً في المرة القادمة (مهم على iOS).
export const warmGreeting = async (userId) => {
  if (read(userId)?.audio) return;
  try {
    const { data } = await fetchGreeting();
    if (data?.disabled) {
      remove(userId);
      return;
    }
    if (data?.audio) write(userId, data.audio, data.mime);
  } catch {
    /* اختياري */
  }
};
